import { getFontSize as getGlobalFontSize } from './global';
export function getFontSize(transformer) {
    const globalFontSize = getGlobalFontSize(transformer);
    return Object.freeze({
        heading: {
            xxl: { value: globalFontSize.xxxl },
            xl: { value: globalFontSize.xxl },
            l: { value: globalFontSize.xl },
            m: { value: globalFontSize.l },
            s: { value: globalFontSize.m },
            xs: { value: globalFontSize.s },
        },
        body: {
            l: { value: globalFontSize.l },
            m: { value: globalFontSize.m },
            s: { value: globalFontSize.s },
        },
        currency: {
            default: {
                l: { value: globalFontSize.xxxl },
                m: { value: globalFontSize.xl },
                s: { value: globalFontSize.m },
            },
            decimals: {
                m: { value: globalFontSize.s },
            },
        },
        button: {
            l: { value: globalFontSize.l },
            m: { value: globalFontSize.m },
            s: { value: globalFontSize.m },
        },
        listItem: {
            description: {
                m: { value: globalFontSize.m },
                l: { value: globalFontSize.xl },
                xl: { value: globalFontSize.xxl },
            },
        },
        form: {
            datepicker: {
                weekDay: { value: globalFontSize.s },
                date: { value: globalFontSize.m },
            },
        },
    });
}
